import React from "react";
import PropTypes from "prop-types";
import { Rating as SemanticRating } from "semantic-ui-react";

import "./Rating.scss";

export const Rating = ({
  size = "lg",
  defaultRating = 3,
  maxRating = 5,
  ...props
}) => {
  return (
    <SemanticRating
      className={`hireart-ds-rating ${size}`}
      icon="star"
      defaultRating={defaultRating}
      maxRating={maxRating}
      {...props}
    />
  );
};

Rating.propTypes = {
  defaultRating: PropTypes.number,
  maxRating: PropTypes.number,
  size: PropTypes.oneOf(["lg", "sm"]),
};

